import React from 'react';
export default class Arrow extends React.Component {
  constructor(props) {
    super(props);
    this.props=props;
    this.iconnames = {left:"chevron_left",right:"chevron_right"};
  }
  getDirection() {
    return this.props.direction.toLower();
  } 
  render() {
    return( <a className={"btn waves-effect waves-light arrow-button" + (this.props.disabled?" disabled":"")} onClick={this.props.onClick}>
        <i className="material-icons">{this.iconnames[this.getDirection()]}</i>
      </a>
    );  
  }
}

export class LeftArrow extends Arrow {
  getDirection() {
    return "left";
  }
}

export class RightArrow extends Arrow {
  getDirection() {
    return "right";
  }
}


// WEBPACK FOOTER //
// ./src/js/components/Arrow/Arrow.jsx